import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import axios from "axios"
import { apiRoot } from './ApiConfig'

const Activate = () => {
  const location = useLocation()
  const [status, setStatus] = useState("Fiók aktiválása folyamatban...")

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const activationKey = params.get("activation_key")
    if (!activationKey) {
      setStatus("Missing activation_key!")
      return
    }

    //axios.post(apiRoot + "api/users/activate", { activation_key: activationKey })
    axios.post(apiRoot + "activate", { activation_key: activationKey })
      .then(res => {
        console.log("activate RES",res)
        if (res.data.success) {
          setStatus("Your VoxDoc account is registered, you can close this browser tab or browser window")
        } else {
          setStatus("Incorrect activation_key!")
        }
      })
      .catch(() => setStatus("An error occurred during activation"))
  }, [location.search])

  return <div className="p-4 text-center">{status}</div>
}

export default Activate